import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=0b3d3056&scoped=true"
import script from "./userAvatar.vue?vue&type=script&lang=js"
export * from "./userAvatar.vue?vue&type=script&lang=js"
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=0b3d3056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d3056",
  null
  
)

export default component.exports